import {getAngle, getOppositeLength} from "./trig";

export default function getCeilingHeight(x, roofHeight, width, freeHeight)
{
    width *= .5;
    const roofAngle = getAngle(roofHeight, width);
    return freeHeight + getOppositeLength(width - Math.abs(x), roofAngle)
}